export default __webpack_public_path__ + "static/media/logo-main.a3e244ff.png";